"use client";

// ============================================================
// CLUBHUB – Das Feld „Funktion“ (ein Amt, kein Recht)
// ============================================================
// Vorschlaege passend zur Gruppenart und zur Person („Kassenwartin“
// fuer sie, „Kassenwart“ fuer ihn, „Kasse“ ohne Angabe), dazu was in
// der Gruppe schon vorkommt; Eigenes laesst sich tippen. Darunter
// steht immer derselbe Satz: eine Funktion vergibt keine Rechte.
// ============================================================
import { useMemo, useState } from "react";
import { Select } from "@/components/ui";
import type { Gender, GroupKind } from "@/generated/prisma/enums";
import { funktionsVorschlaege } from "@/lib/gruppen/logik";

export const FUNKTION_IST_KEIN_RECHT =
  "Eine Funktion ist ein Amt und gibt keine Rechte. Was jemand im System darf, regelt die Rolle unter Einstellungen › Benutzer.";

export function FunktionsFeld({
  kind,
  gender,
  wert,
  onChange,
  inGruppe = [],
  name = "function",
  label = "Funktion",
  hint = FUNKTION_IST_KEIN_RECHT,
}: {
  kind: GroupKind;
  gender?: Gender | null;
  wert: string;
  onChange: (funktion: string) => void;
  /** Funktionen, die in der Gruppe schon vergeben sind oder waren. */
  inGruppe?: (string | null)[];
  name?: string;
  label?: string;
  hint?: string;
}) {
  const [eigene, setEigene] = useState<string[]>([]);
  const optionen = useMemo(() => {
    const vorschlag = funktionsVorschlaege(kind, gender);
    const schon = inGruppe.filter((f): f is string => Boolean(f) && !vorschlag.includes(f!));
    const alle = [...new Set([...vorschlag, ...schon, ...eigene, ...(wert ? [wert] : [])])];
    return [
      { value: "", label: "Keine Funktion" },
      ...alle.map((f) => ({
        value: f,
        label: f,
        group: vorschlag.includes(f) ? "Üblich" : "In dieser Gruppe",
      })),
    ];
  }, [kind, gender, inGruppe, eigene, wert]);

  return (
    <Select
      name={name}
      label={label}
      value={wert}
      onChange={onChange}
      options={optionen}
      searchable
      creatable={{
        onCreate: (getippt) => {
          setEigene((e) => [...e, getippt]);
          onChange(getippt);
        },
        label: (getippt) => `„${getippt}“ als Funktion`,
      }}
      hint={hint}
    />
  );
}
